import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import {
    DatiqInputErrorTypes,
    IDatiqOption,
} from '@dat/datiq-components-pkg/utils';

export const selectMatchesOptions: (options: IDatiqOption[]) => ValidatorFn =
    (options: IDatiqOption[]) =>
    (control: AbstractControl): ValidationErrors | null => {
        const noValue = control.value === undefined && control.value === null;
        const selectValue = options.some(
            (option: IDatiqOption) => option.value === control.value, //this matches for selectControl
        );
        const inputValue = options.some(
            (option: IDatiqOption) =>
                option === control.value ||
                option.value === control.value?.value, // this matches for inputControl
        );

        // undefined and null are valid. if you need to exclude these, use the required validator

        return noValue || selectValue || inputValue
            ? null
            : {
                  [DatiqInputErrorTypes.SelectMatchesOptions]: false,
              };
    };
